import axios from 'axios';

export const SmartshileService = () => {
  const getDataSet = (referenceId, token, page = 1, limit = 100, search = '') => {
    const params = new URLSearchParams();
    const hasParent = referenceId !== undefined && referenceId !== null && referenceId !== '';
    if (hasParent) {
      params.append('parent', referenceId);
    }
    // Only add search param when there's no parent
    if (search && !hasParent) {
      params.append('q', search);
    }
    params.append('page', page);
    params.append('limit', limit);

    return axios
      .get(`${window.REACT_APP_API_PURE}datasetrecord?${params.toString()}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => ({
        data: res.data?.data || res.data || [],
        totalCount: res.data?.totalCount || 0,
      }))
      .catch((err) => {
        throw err;
      });
  };
  return {
    getDataSet,
  };
};

export default SmartshileService;
